<template>
    <div class="card rounded-0 mb-3">
        <h3 class="card-header">
            Account Deleted
        </h3>
        <div class="card-body">
            <div class="alert-warning">{{failureMessage}}</div>
            <div class="form-group">
                <div>
                    Your account has been deleted and your personal information has been removed from our systems.
                    <br />
                    You may re-register at any time.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
</script>

<style scoped>
    div {
        margin-bottom: 20px;
        margin-left: 10px;
    }
</style>